import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  productListLoading: false,
  productViewList: [],
  platformHeaders: [],
  consolidatedCalculation: {},
  total: 0,
  size: 0,
  totalPages: 0,
  page: 0,
  loaderForButton: false,
};
const ProductListSlice = createSlice({
  name: "ProductList",
  initialState,
  reducers: {
    setProductLoading(state, action) {
      state.productListLoading = action?.payload;
    },
    setProductViewList(state, action) {
      state.platformHeaders = action?.payload?.platformHeaders
      state.productViewList = action?.payload?.pagination
        ? [...state.productViewList, ...action?.payload?.productViewList]
        : action?.payload?.productViewList;
      state.consolidatedCalculation = action?.payload?.consolidatedCalculation;
      state.total = action?.payload?.total;
      state.totalPages = action?.payload?.totalPages;
      state.page = action?.payload?.page;
      state.size = action?.payload?.size;
      state.loaderForButton = action?.payload?.loaderForButton;
      state.productListLoading = action?.payload?.productListLoading;
    },
    setLoaderForButton(state, action) {
      state.loaderForButton = action?.payload;
    },
    clearProductViewList(action, state) {
      return initialState;
    },
  },
});

export const ProductListActions = ProductListSlice.actions;

export default ProductListSlice;
